/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";

export const DocumentIcon = (props: any) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="40" height="40" rx="20" fill="#D1FADF" />
    <path
      d="M17.75 16.375V32.625H30.25V20.4961L30.0742 20.3008L26.3242 16.5508L26.1289 16.375H17.75ZM19 17.625H25.25V21.375H29V31.375H19V17.625ZM26.5 18.5234L28.1016 20.125H26.5V18.5234ZM20.875 22.625V23.875H27.125V22.625H20.875ZM20.875 25.125V26.375H27.125V25.125H20.875ZM20.875 27.625V28.875H27.125V27.625H20.875Z"
      fill="#333333"
    />
    <rect
      x="4"
      y="4"
      width="40"
      height="40"
      rx="20"
      stroke="#ECFDF3"
      strokeWidth="8"
    />
  </svg>
);
